import type { CSSProperties } from "react";
import { inkOn, initials } from "../lib/format";

export function BrandMark({ name, color, logoUrl, className = "brand-mark" }: { name: string; color?: string | undefined; logoUrl?: string | undefined; className?: string }) {
  if (logoUrl) return <img className={`${className} logo`} src={logoUrl} alt="" />;
  const c = color && /^#[0-9a-f]{6}$/i.test(color) ? color : "#2446d4";
  const style = { "--brand": c, color: inkOn(c) } as CSSProperties;
  return (
    <div className={className} style={style} aria-hidden="true">
      {initials(name)}
    </div>
  );
}
